<template>
	<div class="suspicious">
		<div class="breadcrumb">可疑用户
			<el-button type="primary" @click="toRuler" class="right_f">可疑规则</el-button>
		</div>
		<div class="search">
			时间：
			<div class="el-input time">
				<el-date-picker type='date' v-model="beginAt" format="yyyy/MM/dd" placeholder="请选择开始时间" class="qizhiDate"></el-date-picker>
			</div>
			-
			<div class="el-input time">
				<el-date-picker type='date' v-model="endAt" format="yyyy/MM/dd" placeholder="请选择结束时间" class="qizhiDate"></el-date-picker>
			</div>

			<div class="el-input">
				<input type="text" placeholder="请输入手机号/用户ID" class="el-input__inner" v-model="keyWords"></input>
			</div>

			<el-button type="primary" @click="getList">可疑用户搜索</el-button>
			<el-button type="primary" @click="getAllUsers">全部用户搜索</el-button>

		</div>

		<div class="datas">
			<el-table :data="list" style="overflow-x: auto;" :row-class-name="tableRowClassName" @select="selectionChange" ref="multipleTable">
				<el-table-column type="index" label="序号" width='80px;'>
				</el-table-column>
				<el-table-column prop="uid" label="用户ID">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" width='130px;'>
				</el-table-column>
				<el-table-column prop="name" label="姓名">
				</el-table-column>
				<el-table-column prop="interestNum" label="关注人数">
				</el-table-column>
				<el-table-column prop="msgNum" label="私信次数">
				</el-table-column>
				<el-table-column prop="date" label="时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="perSign" label="个性签名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="背景图" inline-template>
					<img :src="row.burl" width='100%' style="padding-top: 8px;">
				</el-table-column>
				<el-table-column label="操作" inline-template>
					<div>
						<el-button class="option" type="text" @click="ban(row,1)" v-if="row.bannedStatus==0">禁用</el-button>
						<el-button class="option" type="text" @click="ban(row,0)" v-if="row.bannedStatus==1">取消禁用</el-button>
					</div>
				</el-table-column>
				<el-table-column type="selection" width="55"></el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination v-show="this.totalCount > 0" layout="prev, pager, next, jumper" :page-size="10" :current-page="currentPage"
				 :total="totalCount" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog :title="title" v-model="dialogFormVisible" custom-class="dialog-content" :modal-append-to-body="false">
				<p>用户ID：{{uid}}</p>
				<p>手机号：{{phone}}</p>
				<p>姓名：{{name}}</p>
				<p>校区：{{campuszone}}</p>
				<p>入学年份：{{enrollmentYear}}</p>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="toDisabled">{{btnMessage}}</el-button>
			</div>
		</el-dialog>

		<el-dialog v-model="dialog" custom-class="dialog-ruleForm" title="封号设置" :modal-append-to-body="false">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
				<el-form-item label="封号时间配置" prop="date">
					<div class="form-content">
						<el-switch on-text="" off-text="" v-model="ruleForm.time"></el-switch>
						<el-date-picker
							v-show="ruleForm.time"
							v-model="ruleForm.endTime"
							type="datetime"
							placeholder="选择日期时间">
						</el-date-picker>
					</div>
					<div class="form-tip">
						不配置时间，则永远封号。可手动解封
					</div>
				</el-form-item>
				<el-form-item label="封号说明" prop="reason">
					<el-input
						type="textarea"
						:rows="4"
						:maxlength="200"
						placeholder="学生登录时展示的封号提示，请谨慎填写"
						v-model="ruleForm.reason">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog = false">取 消</el-button>
				<el-button type="primary" @click="handleBanaction(1)">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			const validateDate = (rule, value, callback) => {
				if (this.ruleForm.time && !this.ruleForm.endTime) {
					console.log(12313);
          			callback(new Error('封号日期不能为空'));
				} else if (new Date(this.ruleForm.endTime).getTime() < new Date().getTime()) {
          			callback(new Error('不能选择过去的日期'));
				} else {
					callback();
				}
			};
			return {
				beginAt: new Date(),
				endAt: new Date(),
				keyWords: "",
				list: [],
				currentPage: 1,
				totalCount: 0,
				dialogFormVisible: false,
				title: '是否直接封号？',
				btnMessage: '',
				uid: '',
				phone: '',
				name: '',
				campuszone: '',
				enrollmentYear: '',
				bannedStatus: 0,
				dialog:false,
				ruleForm:{
					time:false,
					endTime:"",
					reason:""
				},
				rules:{
					endTime:[
						{ required: true,validator: validateDate }
					],
					reason: [
						{ required: true, message: '请填写封号说明', trigger: 'blur' }
					]
				}
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			// 禁用用户/解除禁用
			toDisabled() {
				if (this.btnMessage === '封号') {
					this.dialog = true
					return
				}
				this.dialogFormVisible = false;
				this.handleBanaction(0)
			},
			// 禁用用户/解除禁用
			ban(row, status) {
				this.uid = row.uid
				if (status) {
					this.dialog = true
					return
				}
				this.handleBanaction(0)
			},
			handleBanaction(bannedStatus) {
					let params = {
						bannedStatus,
						uid: this.uid
					}
					if (bannedStatus) {
				this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					const { time,reason } = this.ruleForm
					if (bannedStatus) {
						params = Object.assign({},params,{
							permanentForbidden: time ? 0 : 1,
							reason
						})
					}
					if (time) {
						params = Object.assign({},params,{
							endTime: new Date(this.ruleForm.endTime).format('yyyy-MM-dd hh:mm:ss')
						})
					}
				} else {
					return false;
				}
				});
					}
					
				this.$http({
					method: "POST",
					url: this.$util.domain + "/adminapi/v4/user/suspicious/banaction",
					body: JSON.stringify({
						...params
					})
				}).then(response => {
					if (response.data.error === 10000) {
						this.$util.successMsg("操作成功");
						this.getList();
					} else {
						this.$util.errorMsg(response.data.message);
					}
					this.dialog = false
				this.dialogFormVisible = false;
				}).catch(error=>{
					this.dialog = false
				this.dialogFormVisible = false;
				})

			},

			// 全部用户搜索
			getAllUsers() {

				if (!this.keyWords || !this.keyWords.trim()) {ban
					return;
				}
				this.$http({
					method: "POST",
					url: this.$util.domain + "/adminapi/v4/user/suspicious/search",
					body: JSON.stringify({
						keyWords: this.keyWords.trim()
					})
				}).then(response => {
					if (response.data.error === 10000) {
						if (response.data.data) {

							this.uid = response.data.data.uid;
							this.phone = response.data.data.phone;
							this.name = response.data.data.name;
							this.campuszone = response.data.data.campuszone;
							this.bannedStatus = response.data.data.bannedStatus
							this.enrollmentYear = response.data.data.enrollmentYear;

							if (response.data.data.bannedStatus == 1) {
								this.title = '是否解封？';
								this.btnMessage = '恢复正常'
							} else {
								this.title = '是否直接封号？';
								this.btnMessage = '封号'
							}
							this.dialogFormVisible = true;
						} else {
							this.$util.errorMsg('未搜索到相关信息')
						}
					}
				});
			},
			//获取可疑列表
			getList() {
				let startTime = new Date(new Date(this.beginAt).format("yyyy/MM/dd 00:00:00")).getTime() * 1;
				let endTime = new Date(new Date(this.endAt).format("yyyy/MM/dd 23:59:59")).getTime() * 1;
				
				if (startTime > endTime) {
					this.$util.errorMsg("搜索的开始时间不可以大于结束时间");
					return;
				}
				this.$http({
					method: "POST",
					url: this.$util.domain + "/adminapi/v4/user/suspicious/userlist",
					body: JSON.stringify({
						startDate: new Date(this.beginAt).format("yyyy/MM/dd"),
						endDate: new Date(this.endAt).format("yyyy/MM/dd"),
						keyWords: this.keyWords.trimLeft(),
						pageNum: this.currentPage,
						pageSize: 10
					})
				}).then(response => {
					this.list.splice(0, this.list.length);
					if (response.data.error === 10000) {
						let data = response.data.data;
						data.content.forEach((item, index) => {
							this.list[index] = item;
							this.list[index].timeStamp = item.date;
							this.list[index].date = new Date(item.date).format("yyyy/MM/dd");
						});
						this.totalCount = data.totalElements;
						this.select(this.list);
					}
				});
			},
			//标记选中的行；
			tableRowClassName(row) {
				if (row.hasRead == 1) {
					return "read-row";
				}
				return;
			},
			//初始时候选中标记的数据行
			select(list) {
				list.forEach(item => {
					if (item.hasRead == 1) {
						this.$refs.multipleTable.toggleRowSelection(item, true);
					}
				});
			},
			selectionChange(row, currentRow) {
				if (currentRow.hasRead == 1) {
					currentRow.hasRead = 0;
					this.tableRowClassName(currentRow);
				} else {
					currentRow.hasRead = 1;
					this.tableRowClassName(currentRow);
				}
				this.$http({
					method: "POST",
					url: this.$util.domain + "/adminapi/v4/user/suspicious/readaction",
					body: JSON.stringify({
						hasRead: currentRow.hasRead,
						suspiciousRecords: [{
							recordDate: currentRow.timeStamp,
							uid: currentRow.uid * 1
						}]
					})
				}).then((response) => {
					if (response.data.error != 10000) {
						this.$util.errorMsg(response.data.message);
					}
				});
			},
			//跳转到可疑规则
			toRuler() {
				location.href = "/#/userM/suspiciousRulers";
			},
			//请求分页数据
			handleCurrentChange(val) {
				this.currentPage = val * 1;
				this.getList();
			}
		}
	};
</script>
<style>
	.suspicious {
		padding-bottom: 40px;
	}

	.suspicious .el-select {
		display: inline-block;
		width: 20%;
	}

	.suspicious .el-input {
		display: inline-block;
        width: auto;
	}

	.suspicious .el-button {
		display: inline-block;
	}

	.suspicious .el-button+.el-button {
		margin-left: 0;
	}

	.search {
		margin-left: 30px;
	}

	.datas {
		margin-top: 20px;
	}

	.el-dialog__body p {
		line-height: 38px;
	}

	.suspicious .time {
		width: 15%;
	}

	.el-table .read-row {
		background: #eff2f7;
	}

	.suspicious thead th:nth-child(11)>div.cell {
		display: none;
	}
	.form-content{
		display: flex;
		align-items: center;
		height: 36px;
	}
	.form-flex-sub{
		flex: 1;
		margin-left: 8px;
	}
	.form-tip{
		margin-top: 8px;
		font-size: 12px;
		line-height: 1.5;
		color: #FF4949;
	}
</style>


// WEBPACK FOOTER //
// suspicious.vue?be2c2254